import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceReaxysInformation from '@Components/Results/substances/information/SubstanceReaxysInformation';

import './SubstanceInformation.scss';

// eslint-disable-next-line react/display-name
const SubstanceInformation = React.memo(({ metadata, substance, database, onToggle, toggleFact, facts, zoom }) => {
  const { index: substanceIndex, details } = substance;
  const { chemicalNames = [] } = details;

  return (
    <div
      id={`substances-${substanceIndex}`}
      className="substance-results-information u-els-padding-top u-els-font-size-base u-els-line-height-default">
      <div className="sub-menu u-els-padding u-els-background-color-n0">
        <div className="substance-info-header">
          <div className="u-els-font-size-h3">
            <InnerHTML tag="span" html={chemicalNames[0]} />
          </div>
          <ButtonWithIcon type="link" iconOnly sprite="Close" data-e2e="sub-menu-close" onClick={onToggle}>
            close
          </ButtonWithIcon>
        </div>
        <SubstanceReaxysInformation
          metadata={metadata}
          facts={facts}
          toggle={toggleFact}
          details={details}
          database={database}
          substanceIndex={substanceIndex}
          zoom={zoom}
          substance={substance}
        />
      </div>
    </div>
  );
});

SubstanceInformation.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  facts: PropTypes.object.isRequired,
  toggleFact: PropTypes.func.isRequired,
  zoom: PropTypes.number,
};

export default SubstanceInformation;
